/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './styles.module.scss';

const FooterShared = ({ className = null, children = null, ...props }) => (
  <footer {...props} className={cx(s.footer, className)}>
    {children}
  </footer>
);

FooterShared.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FooterShared;
